import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { InvestmentTransactionCollection } from '../../Models/Domains/Transactions/Investments/InvestmentTransactionCollection';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class InvestmentTransactionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, modelId: number, fromDate: IJsonDate, toDate: IJsonDate, transSource: string, instrumentCode: string, cNoteID: number, sortName: string, sortDirection: string, minRow: number, maxRow: number): Promise<InvestmentTransactionCollection, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/InvestmentTransaction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, modelId: modelId, fromDate: fromDate, toDate: toDate, transSource: transSource, instrumentCode: instrumentCode, cNoteID: cNoteID, sortName: sortName, sortDirection: sortDirection, minRow: minRow, maxRow: maxRow }

    return AjaxWrapper.get<InvestmentTransactionCollection, any>(url, data);
  }
}

